import React from 'react';

export const ProgressBar = ({ currentStep, totalSteps }) => {
  return (
    <div className="w-full mb-8" data-testid="progress-bar">
      {/* Step indicator */}
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-slate-600">
          Étape {currentStep + 1} sur {totalSteps}
        </span>
        <span className="text-sm text-slate-400">
          {Math.round(((currentStep + 1) / totalSteps) * 100)}%
        </span>
      </div>
      
      {/* Progress bar */}
      <div className="flex gap-1">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`progress-step ${
              index < currentStep
                ? 'completed'
                : index === currentStep
                ? 'active'
                : ''
            }`}
            data-testid={`progress-step-${index}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
